import { HeaderTextProps } from 'components/organisms/Header/types';

const header: HeaderTextProps = {
    headerText: {
        greetings: 'Bonjour',
        intro: "Je suis",
        preTitle: 'un',
    },
    scrollDown: 'Défiler vers le bas',
};

export default header;
